<div [class.smart-assistant-module-collapse]="!showAll" [style.max-height]="maxHeight">
    <!-- 帮助提示 -->
    <div class="smart-assistant-alarms-help-container mb-6" *ngIf="data.recent.length !== 0">
        <app-smart-assistant-switch [content]="i18nLabel.helpTitle" [showIcon]="false"></app-smart-assistant-switch>
    </div>
    <!-- 告警列表 -->
    <ul class="alarm-list">
        <li class="alarm-list-item flex-style" *ngFor="let alarm of data.recent"
            style="border-bottom: none; height: 88px;">
            <!-- 告警描述 -->
            <div class="alarm-list-item-title flex-style" style="cursor: default; font-weight: normal;">
                <span [className]="'alarm-level-' + alarm.level"></span>
                <span class="text text-ellipsis">{{decodeHTML(alarm.description)}}</span>
            </div>
            <!-- 时间 -->
            <div class="alarm-list-item-time">{{alarm.startTimeStr}}</div>
            <div class="alarm-list-item-btns">
                <!-- 查看详情 -->
                <button nButton theme="text" (click)="onlyShowDetail(alarm)" [label]="i18nLabel.detailLabel"></button>
                <!-- 收集相关信息 -->
                <button nButton theme="text" (click)="doCollection(alarm)" [label]="i18nLabel.infoCollect"></button>
            </div>
        </li>
    </ul>
</div>
